export const stripRedTextMarkers = (text: string) => {
  return text.replace(/RedTextStart:|:RedTextEnd/g, '');
};
